import { ChevronRight } from "@mui/icons-material";
import { ButtonBase, Typography, alpha, useTheme } from "@mui/material";

interface DashViewAllButtonProps {
  onClick: () => void;
  label?: string;
  /** Contagem opcional — ex.: "Ver tudo (5)" */
  count?: number;
  /** inline = chip no header; block = faixa abaixo do conteúdo */
  variant?: "inline" | "block";
  fullWidth?: boolean;
}

/** CTA "Ver tudo" padronizado do dashboard mobile. */
export function DashViewAllButton({
  onClick,
  label = "Ver tudo",
  count,
  variant = "block",
  fullWidth = true,
}: DashViewAllButtonProps) {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const isInline = variant === "inline";
  const displayLabel =
    count != null && count > 0 ? `${label} (${count})` : label;

  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        WebkitTapHighlightColor: "transparent",
        transition: "background-color 0.15s ease, transform 0.12s ease",
        bgcolor: alpha(primary, isInline ? 0.08 : 0.05),
        border: "1px solid",
        borderColor: alpha(primary, isInline ? 0.16 : 0.12),
        "&:active": {
          transform: "scale(0.98)",
          bgcolor: alpha(primary, 0.12),
        },
        ...(isInline
          ? {
              flexShrink: 0,
              display: "inline-flex",
              alignItems: "center",
              gap: 0.1,
              py: 0.45,
              px: 1.15,
              borderRadius: 99,
              mt: 0.05,
            }
          : {
              width: fullWidth ? "100%" : "auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 0.35,
              py: 0.9,
              px: 1.5,
              mt: 1,
              borderRadius: 2.5,
            }),
      }}
    >
      <Typography
        component="span"
        variant="caption"
        sx={{
          fontWeight: 700,
          fontSize: isInline ? "0.6875rem" : "0.75rem",
          color: "primary.main",
          lineHeight: 1.2,
        }}
      >
        {displayLabel}
      </Typography>
      <ChevronRight
        sx={{
          fontSize: isInline ? 14 : 17,
          color: "primary.main",
          ml: isInline ? -0.2 : 0,
        }}
      />
    </ButtonBase>
  );
}
